import { DataSourceFactory } from 'app/components';

interface IPublicData {
  date: string;
  foundationMarkIndex: number;
  ein: string;
  giv: number;
  sixtyforty: number;
  barclay: number;
  spFiveHundred: number;
}

interface IAnnualizedData {
  index: string;
  oneMonth: number;
  threeMonth: number;
  yearToDate: number;
  year: number;
  threeYear: number;
  fiveYear: number;
  tenYear: number;
}

const filterBody = { monthNumber: '12' };
const givTrendFilterBody = { action: 'getGIVIndexTrend', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } };
const givTableFilterBody = { action: 'getGIVIndexTable', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } };
const givAnnualizedFilterBody = { action: 'getAnnualizedDataTable', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } };

const FoundationMarkDataSources = DataSourceFactory.create<IPublicData>({
  transport: {
    read: {
      url: 'https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationindextrend',
      request: { method: 'POST' },
    },
  },
});

const GIVTrendDataSource = DataSourceFactory.create<IPublicData>({
  transport: {
    read: {
      url: 'https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests',
      insertBodyBeforeRequest: () => JSON.stringify(givTrendFilterBody),
      request: { method: 'POST' },
    },
  },
});

const GIVTableDataSource = DataSourceFactory.create<IPublicData>({
  transport: {
    read: {
      url: 'https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests',
      insertBodyBeforeRequest: () => JSON.stringify(givTableFilterBody),
      request: { method: 'POST' },
    },
  },
});

const GIVAnnualizedDataSource = DataSourceFactory.create<IAnnualizedData[]>({
  transport: {
    read: {
      url: 'https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests',
      insertBodyBeforeRequest: () => JSON.stringify(givAnnualizedFilterBody),
      request: { method: 'POST' },
    },
  },
});

const filterAndSyncDataSource = (monthNumber: string) => {
  filterBody.monthNumber = monthNumber;

  FoundationMarkDataSources.sync();
};

export { FoundationMarkDataSources, IPublicData, filterAndSyncDataSource, GIVTrendDataSource, GIVTableDataSource, GIVAnnualizedDataSource };



// WEBPACK FOOTER //
// ./src/app/containers/Home/DataSources.ts